module.exports = __webpack_public_path__ + "static/media/astro-tours-broome.eb16983a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/astro-tours-broome.jpg
// module id = 165
// module chunks = 0